@if (type === 'teached') {
  <h1>Обученные пользователи</h1>
}
@if (type === 'staff') {
  <h1>Все пользователи</h1>
}
@if (type === 'refusal') {
  <h1>Необученные пользователи</h1>
}

<app-simple-table>
  <app-simple-table-th>№ п/п</app-simple-table-th>
  <app-simple-table-th [name]="'physical_fio'">ФИО</app-simple-table-th>
  <app-simple-table-th [name]="'physical_phone'">Телефон</app-simple-table-th>
  <app-simple-table-th [name]="'physical_email'">Телефон</app-simple-table-th>
  <!--//-->
  @for (row of listArr; track row; let i = $index) {
    <app-simple-table-tr>
      <td>{{i+1}}</td>
      <td>{{row['physical_fio']}}</td>
      <td>{{row['physical_phone']}}</td>
      <td>{{row['physical_email']}}</td>
    </app-simple-table-tr>
  }
</app-simple-table>
